module.exports = __webpack_public_path__ + "img/nature-23.da357cd0.jpg";